<div class="bucket-option truncate">
  <div class="bucket-option__value truncate">
    {{ bucketOption().value.value }}
  </div>
  <span class="bucket-option__label truncate"> {{ bucketOption().label }}</span>
</div>

<span class="bucket-option-count">
  {{ bucketOption().value.count }}
</span>
